import { Text } from "@ui-component-library";
import MediaSelector from "../editor/fields/MediaSelector";

const PersonaSection = (props) => {

  const backgroundColor = !props.backgroundColor ? 'bg-white' : `bg-[${props.backgroundColor}]`;

  return (
    <div className={`${backgroundColor}`}>
      <section className='container py-24'>
        <Text variant="text-sm/leading-normal/medium" className="text-[#737373] mb-5">{props.sectionName}</Text>

        <Text variant="text-4xl/leading-normal/medium" className="text-[#0F0F0F] mb-12">{props.title}</Text>

        <div className="grid grid-cols-1 gap-x-6 gap-y-12 md:grid-cols-3">
          {props.personas.map((persona, index) => (
            <div key={index} className="flex min-w-0 flex-col gap-4">
              <img src={persona.src} alt={persona.alt} className="w-full aspect-square object-cover rounded-lg" />

              {(persona.name || persona.profession) && <div>
                {persona.name && <Text variant="text-base/leading-normal/medium" className="text-[#0F0F0F]">{persona.name}</Text>}
                {persona.profession && <Text variant="text-sm/leading-normal/normal" className="text-[#737373]">{persona.profession}</Text>}
              </div>}
              
              {(persona.phone || persona.email) && <div>
                {persona.phone && <Text variant="text-base/leading-normal/normal" className="text-[#1A1A1A] cursor-pointer" onClick={() => window.location.href = `tel:${persona.phoneLink}`}>{persona.phone}</Text>}
                {persona.email && <Text variant="text-base/leading-normal/normal" className="text-[#1A1A1A] cursor-pointer" onClick={() => window.location.href = `mailto:${persona.email}`}>{persona.email}</Text>}
              </div>}

              {persona.description && <Text variant="text-sm/leading-normal/normal" className="text-[#737373]">{persona.description}</Text>}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

PersonaSection.defaultProps = {
    sectionName: "Persona section",
    title: "Headline that introduces the personas.",
    backgroundColor: '',
    personas: [
      {
        name: "Adam Johnsson",
        profession: "Forestranger",
        description: "Adam is a forestranger who is looking for a new job.",
        phone: "070-000 00 00",
        phoneLink: "+46700000000",
        email: "adam.johnsson@example.com",
        src: "https://placehold.co/400x400",
        alt: "Adam Johnsson",
      },
      {
        name: "Adam Johnsson",
        profession: "Forestranger",
        description: "Adam is a forestranger who is looking for a new job.",
        phone: "070-000 00 00",
        phoneLink: "+46700000000",
        email: "adam.johnsson@example.com",
        src: "https://placehold.co/400x400",
        alt: "Adam Johnsson",
      },
      {
        name: "Adam Johnsson",
        profession: "Forestranger",
        description: "Adam is a forestranger who is looking for a new job.",
        phone: "070-000 00 00",
        phoneLink: "+46700000000",
        email: "adam.johnsson@example.com",
        src: "https://placehold.co/400x400",
        alt: "Adam Johnsson",
      }
    ],
  };
  
  PersonaSection.fields = {
    sectionName: {
        type: "text",
        label: "Section name",
    },
    title: {
        type: "text",
        label: "Section title",
    },
    backgroundColor: {
        type: "text",
        label: "Background color",
    },
    personas: {
        type: "array",
        arrayFields: {
            name: { type: "text" },
            profession: { type: "text" },
            description: { type: "textarea" },
            phone: { type: "text" },
            phoneLink: { type: "text" },
            email: { type: "text" },
            src: {
                type: "custom",
                label: "Image Source",
                render: ({ name, onChange, value }) => (
                    <MediaSelector
                    name={name}
                    label="Image Source"
                    type={"img"}
                    onChange={onChange}
                    value={value}
                    />
                ),
            },
            alt: {
                type: "text",
                label: "Image Alt Text",
            },
        },
        defaultItemProps: PersonaSection.defaultProps.personas[0],
    }
};  

export default PersonaSection;
